import React, { useState } from 'react'

//Dependencies.
import { Link, useLocation, useParams } from 'react-router-dom'

//Components.
import NewVideoModal from '../../Modal/new-video/NewVideoModal';

import './CurrentUserNavbar.styles.css';


const CurrentUserNavbar = () => {
  const location = useLocation();
  const params = useParams();
  const [videoModal, setVideoModal] = useState(false);

  return (
    <nav>
      {
        !location.pathname.endsWith("/home")
        &&
        <Link to={`/member/_userID/${params._userID}/home`}><strong>USER'S HOMEPAGE</strong></Link>
      } 
      <strong onClick={() => setVideoModal(!videoModal)} style={{ cursor: 'pointer' }}>ADD NEW VIDEO.</strong>      
      {
        videoModal && <NewVideoModal modal={videoModal} setModal={setVideoModal} />
      }
      
      <Link to={`/member/_userID/${params._userID}/challenges/create`}><strong style={{ cursor: 'pointer' }}>CREATE A CHALLENGE.</strong></Link>

      <Link to={`stats`}><strong>MY STATS</strong></Link>      
      <strong style={{cursor: 'pointer'}}>ACCOUNT INFORMATION.</strong>
    </nav>
  )
}

export default CurrentUserNavbar